<div class="canvas-root">
  <div #container class="canvas"></div>

  @if (viewNodes.length === 0) {
    <div class="empty-overlay">
      <div class="empty-title">まずは ViewField ノードを追加してください</div>
      <div class="empty-hint">右上の「+ ViewFieldノード」→ 右ペインで fieldName を入力 → Entity から線で接続</div>
    </div>
  }
</div>

